interface IProps {
    size?: string;
}

export const PointPIcon = (props: IProps) => {
    const { size } = props;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size || "16"}
            height={size || "16"}
            viewBox="0 0 16 16"
            fill="none"
        >
            <g filter="url(#filter0_d_767_270)">
                <circle
                    cx="8"
                    cy="6"
                    r="5.5"
                    fill="url(#paint0_radial_767_270)"
                    stroke="url(#paint1_linear_767_270)"
                />
                <path
                    d="M6.125 9.375V3H8.64014C9.12366 3 9.53558 3.09235 9.87592 3.27704C10.2162 3.45966 10.4756 3.71387 10.6541 4.03967C10.8347 4.3634 10.9249 4.73694 10.9249 5.16028C10.9249 5.58362 10.8336 5.95715 10.651 6.28088C10.4684 6.60461 10.2038 6.85675 9.85724 7.03729C9.51276 7.21783 9.09564 7.30811 8.6059 7.30811H7.00281V6.22797H8.388C8.6474 6.22797 8.86114 6.18335 9.02924 6.09412C9.1994 6.00281 9.32599 5.87726 9.409 5.71747C9.49408 5.5556 9.53662 5.36987 9.53662 5.16028C9.53662 4.94861 9.49408 4.76392 9.409 4.6062C9.32599 4.44641 9.1994 4.32294 9.02924 4.23578C8.85907 4.14655 8.64325 4.10193 8.38177 4.10193H7.47284V9.375H6.125Z"
                    fill="url(#paint2_linear_767_270)"
                />
            </g>
            <defs>
                <filter
                    id="filter0_d_767_270"
                    x="0"
                    y="0"
                    width="16"
                    height="16"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="1" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.952941 0 0 0 0 0.721569 0 0 0 0 0.239216 0 0 0 0.16 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_767_270"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_767_270"
                        result="shape"
                    />
                </filter>
                <radialGradient
                    id="paint0_radial_767_270"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(7.94783 5.37391) rotate(89.5489) scale(6.62629 7.34294)"
                >
                    <stop stop-color="#F2CA3C" />
                    <stop offset="1" stop-color="#F2AA3C" />
                </radialGradient>
                <linearGradient
                    id="paint1_linear_767_270"
                    x1="11.1826"
                    y1="11.7391"
                    x2="3.66957"
                    y2="1.98261"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#C89137" />
                    <stop offset="1" stop-color="#FFF500" stop-opacity="0.2" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_767_270"
                    x1="8.52496"
                    y1="3"
                    x2="8.52496"
                    y2="9.375"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#FEF7E6" />
                    <stop offset="1" stop-color="#FFFFFD" />
                </linearGradient>
            </defs>
        </svg>
    );
};
